import { render } from "./AddSummary.vue?vue&type=template&id=04d70800&scoped=true"
import script from "./AddSummary.vue?vue&type=script&lang=js"
export * from "./AddSummary.vue?vue&type=script&lang=js"

import "./AddSummary.vue?vue&type=style&index=0&id=04d70800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d70800"]])

export default __exports__